/*
Author: Shivakumar
Date: 06/12//2019
Issue Description: Login Screen: Error state sentences should be changed
search_string: PL-2061
*/

/*
Author: Vinod
Date: 19/03/2020
Issue Description: After session time out, if we are logging in with different credential also, we are redirecting to previous user LE screen, from where it was session timed out.
search_string: PL_2925
*/

<template>
  <login-shell>
    <div class="signin-text">
      <span class="signin">Sign In</span>
    </div>
    <hr class="separator" />
    <div class="signin-form">
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <br />
      <form v-on:submit.prevent="onSignInClick()">
        <div>
          <p class="label companyCode">Company Code</p>
          <input
            class="input-field companyCode"
            id="companyCode"
            type="text"
            name="companyCode"
            autocomplete="on"
            v-model="formData.companyCode"
            placeholder="Company Code"
            v-validate="{required: true, alpha_num:true, max:100}"
          />
          <span
            class="errorMessage"
            v-show="errors.has('companyCode') && !formData.companyCode"
          >Please enter company code</span>
          <!-- PL-2061 -->
          <span
            class="errorMessage"
            v-show="errors.has('companyCode') && formData.companyCode"
          >Please enter correct company code</span>
          <p class="label">Username</p>
          <input
            class="input-field"
            id="email"
            type="text"
            name="email"
            autocomplete="off"
            v-model="formData.username"
            placeholder="User Name"
            v-validate="{required: true, max:100}"
          />
          <span
            class="errorMessage"
            v-show="errors.has('email') && !formData.username"
          >Please enter user name</span>
          <!-- PL-2061 -->
          <span
            class="errorMessage"
            v-show="errors.has('email') && formData.username"
          >Please enter correct user name</span>
          <!-- PL-2061 -->
          <br />
          <br />
          <p class="label">Password</p>
          <div class="password">
            <input
              class="input-field"
              :type="passwordtype"
              name="password"
              autocomplete="off"
              v-model="formData.password"
              placeholder="Enter Password"
              v-validate="{required:true}"
            />
            <i class="material-icons pointer" v-on:click="toggleimg()" md-18 md-inactive>{{icon}}</i>
          </div>
          <span class="errorMessage" v-show="errors.has('password')">{{ errors.first('password') }}</span>
          <!-- <div class="checkbox">
            <input type="checkbox" />&nbsp;
            <span class="remember">Remember me</span>
            <a class="forget-password-btn" @click="onForgotPasswordClick()">Forgot Password</a>
          </div> -->
        </div>
        <button type="submit" class="signin-btn">Login</button>
        <!-- <button type="submit" class="signin-btn">Sign In</button> -->
        <div class="checkbox">
            <input type="checkbox" />&nbsp;
            <span class="remember">Remember me</span>
            <a class="forget-password-btn" @click="onForgotPasswordClick()">Forgot Password</a>
        </div>
      </form>
      <form v-on:submit.prevent="sendLink()">
        <div class="modal" v-show="showResetPasswordModal">
          <div class="modal-content">
            <toast-message
              :message="forgotPasswordErrorMessage"
              type="error"
              :isToastEnable="forgotPasswordToast"
              @close="(val) => forgotPasswordToast = val"
            />
            <p class="header header3 forgpass">
              <span class="text">Forgot Password</span>
            </p>
            <span
              class="label"
            >Enter your User name and we will send you the link to reset your password.</span>
            <br />
            <p class="label companyCode">Company Code</p>
          <input
            class="input-field companyCode"
            type="text"
            name="company Code"
            autocomplete="off"
            v-model="forgotPasswordCompanyCodeUserIdentity"
            placeholder="Company Code"
            v-validate="`required_if:${forgotPasswordCompanyCodeUserIdentity.length}`"
          />
          <span
            class="errorMessage"
            v-show="errors.has('company Code') && !formData.companyCode"
          >Please enter company code</span>
          <!-- PL-2061 -->
          <span
            class="errorMessage"
            v-show="errors.has('company Code') && formData.companyCode"
          >Please enter correct company code</span>
          <p class="label companyCode">User Name</p>
            <input
              class="input-field"
              autofocus="autofocus"
              type="email"
              v-model="forgotPasswordUserIdentity"
              name="forgot password"
              placeholder="User name"
              id="forgot password"
              
              @onValueChange="sendLink"
            />
            <span
              class="errorMessage"
              v-show="errors.has('forgot password')"
            >The forgot password field must be a valid user name</span>
            <div class="popup-btns">
              <a @click="cancel" class="cursor btn secondary">Cancel</a>
              <btn
                :disabled="errors.has('forgot password') || !(forgotPasswordUserIdentity.length)"
                text="Send reset link"
                type="primary"
                @click="sendLink"
              ></btn>
            </div>
          </div>
        </div>
      </form>
      <pop-up-message
        v-if="showSuccessMsg"
        :message="`
           Reset password link has been sent to registered email id. Please reset your password.`"
        btnText="OK"
        @back="ok"
      ></pop-up-message>
    </div>
  </login-shell>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import LoginShell from "./loginShell.vue";
import * as globalRegexVar from "@/apis/config.js";

export default {
  data() {
    return {
      forgotPasswordErrorMessage: "",
      emailRegex: null,
      passwordValidate: null,
      toast: false,
      errmsg: "",
      formData: {
        username: "",
        password: "",
        companyCode:""
      },
      forgotPasswordUserIdentity: "",
      forgotPasswordCompanyCodeUserIdentity: "",
      showResetPasswordModal: false,
      showSuccessMsg: false,
      passwordtype: "password",
      icon: "visibility_off",
      forgotPasswordToast: false
    };
  },
  components: {
    LoginShell
  },

  mounted() {
    try {
      if (this.token) {
       this.$router.push({ path: "/welcome" });
      }
      this.emailRegex = globalRegexVar.Regex.EMAIL;
      this.passwordValidate = globalRegexVar.Regex.PASSWORD;
    } catch (err) {
      this.errmsg = err;
      this.toast = true;
    }
  },

  computed: {
    ...mapState({
      token: state => state.auth.token,
      empId: state => state.auth.employeeId,
      empIdenempIdentity: state=>state.auth.formData.username
    })
    // le_id() {
    //   if (this.$route.params.entity_index)
    //     return this.getleid(this.$route.params.entity_index);
    //   else return this.getleid(0);
    // },
  },

  methods: {
    ...mapGetters({
      isAuth: "auth/isAuth",
      //getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    ...mapActions({
      signinUsingPassword: "auth/signinUsingPassword",
      signInWithGoogle: "auth/signInWithGoogle",
      userForgotPassword: "auth/forgotPassword",
      act_setOrgId: "onboard/organization/changeOrgId",
      act_SetAuthOrgId: "auth/changeTheNewOrg",
    }),

    /** To Toggle the eye icon to show/hide password text */
    toggleimg() {
      try {
        if (this.passwordtype == "password") {
          this.passwordtype = "text";
          this.icon = "visibility";
        } else {
          this.passwordtype = "password";
          this.icon = "visibility_off";
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** On Sign in button click */
    async onSignInClick() {
      try {
        window.localStorage.clear()
        this.$validator.validateAll().then(result => {
          if (result) {
            this.errmsg = "";
            this.toast = false;
            this.performAction();
          }
        });
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /** Server call to get Sign-in for a user */
    async performAction() {
      try {
        this.employeeId = this.empId;      // PL_2925
        let data = await this.signinUsingPassword({
          identity: this.formData.username,
          password: this.formData.password,
          companyCode: this.formData.companyCode,
          provider: "password"
        });

        //console.log("Dataaa 244+===>>>>",data);
        if (data && data.status) {
          //window.localStorage.removeItem("token");
          window.localStorage.setItem("token", data.data.payload.token);
          window.localStorage.setItem("companyCode", this.formData.companyCode)

          /*** START: Show the organisation according to anchor user role */
          if(data.data.payload.userRole === 'HR' || data.data.payload.userRole === 'EMPLOYEE') {
                let orgId = data.data.payload.org_id;
                const permissionOrgs = data.data.payload.le_id;
                //this.act_setOrgId(orgId);
                //this.act_SetAuthOrgId(orgId);
                setTimeout(() => {
                this.$router.push({ path: `/dashboard/0/overview/feed` });
                window.location.reload();
            }, 100);
          } else if(data.data.payload.userRole === 'CLIENTADMIN'){
            setTimeout(() => {
                this.$router.push({ path: `/clientOrgSummary` });
                window.location.reload();
            }, 100);
          } 
          
          else {
                setTimeout(() => {
                  this.$router.push({ path: "/welcome" });
                // End PL_2925
                window.location.reload();
                }, 100);
          }
        /*** END: Show the organisation according to anchor user role */

          // setTimeout(() => {
          //     this.$router.push({ path: "/welcome" });
          //   // End PL_2925
          //   window.location.reload();
          // }, 100);

          /***** Alternate for not skipping Dual Authentication *****/
          /*
          let encodedString1 = btoa(
            data.data.payload.email ? data.data.payload.email : ""
          );
          let encodedString2 = btoa(
            data.data.payload.mobile ? data.data.payload.mobile : ""
          );

          this.$router.push({ path: 'verifyotp'})
          this.$router.push({
            path: "verifyotp",
            query: { email: encodedString1 , mobile: encodedString2}
          });
          if(!this.$route.query.entry_url)
           this.$router.push({path: "/onboarding"});
          else
            this.$router.push({path: this.$route.query.entry_url});
            */
        } else {
          this.errmsg = data
            ? data
            : "Sorry, unable to process request right now. Please try again later or contact the Admin if problem persists.";
          this.toast = true;
        }
      } catch (err) {
      console.log(err)
        if(err){
          this.errmsg = err;
        this.toast = true;
        }else{
        this.errmsg = "Please log out from your previous session or refresh the page and try again.";
        this.toast = true;
        }
      }
    },

    /** Used for Google login process */
    async onSignIn(googleUser) {
      try {
        let email = googleUser.getBasicProfile().getEmail();
        let token = googleUser.getAuthResponse().id_token;
        await this.signInWithGoogle({
          identity: email,
          token: token
        });
        this.$router.push({
          path: "/welcome"
        });
      } catch (err) {
        this.errmsg = err.message;
        this.toast = true;
      }
    },

    /** On forgot password click  */
    onForgotPasswordClick() {
      try {
        this.forgotPasswordUserIdentity = this.formData.username;
        this.forgotPasswordCompanyCodeUserIdentity = this.formData.companyCode
        this.showResetPasswordModal = true;
      } catch (err) {
        this.errmsg = err.message;
        this.toast = true;
      }
    },
    cancel() {
      this.showResetPasswordModal = false;
    },

    /** To send the an email to user to reset password  */
    async sendLink() {
      try {
        this.$root._data.isSaving = true;
        let data = await this.userForgotPassword({
          ecode: this.forgotPasswordUserIdentity,
          companyCode: this.forgotPasswordCompanyCodeUserIdentity
        });
        if (data && data.status) {
          this.forgotPasswordErrorMessage = "";
          this.forgotPasswordToast = false;
          this.showResetPasswordModal = false;
          this.showSuccessMsg = true;
        }
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.forgotPasswordErrorMessage = err;
        this.forgotPasswordToast = true;
        this.$root._data.isSaving = false;
      }
    },

    ok() {
      this.showSuccessMsg = false;
    }
  }
};
</script>

<style lang='scss' scoped>
.signin-form {
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
  //box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.2);  comment old code
}
.signin-form form {
  padding: 10px 40px 25px;
}
.label {
  height: 15px; // margin-top: 25px;
  margin-bottom: 9px;
  font-family: Montserrat;
  font-size: 13px;
  color: #0e0e0e;
}

.remember {
  height: 16px;
  font-family: Montserrat;
  font-size: 14px;
  color: #0e0e0e;
}

.signin-form .input-field {
  width: 100%;
  height: 43px;
  border-radius: 6px;
  padding: 10px;
  outline: 0;
  border: 1px solid #d8d8d8;
  background-color: #ffffff;
  &:focus {
    outline: none;
    border: 2px solid #34c0be;
  }
}
.checkbox {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.forget-password-btn {
  cursor: pointer;
  font-family: Montserrat;
  font-size: 13px;
  text-decoration: none;
  margin-left: auto;
  //color: #5d409f;  comment old code
  font-weight: 600; // Add this css new
  color: #34c0be; // Add this css new
}
.signin-btn {
  margin-top: 50px;
  width: 100%;
  cursor: pointer;
  height: 45px;
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  border: none;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #5d409f;
}
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6);
}

/* Modal Content */

.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 400px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 30px 36px 36px 36px;

  .success-icon {
    margin-bottom: 40px;
  }
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
  .success-text {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: auto;
  }

  .message-text {
    font-size: 14px;
    margin-bottom: auto;
  }

  .effDateClass {
    margin-bottom: 5%;
  }
  .popup-btns {
    margin-top: 10%;
    display: flex;
    justify-content: space-between;
    a {
      /*margin-top: 4%;
      margin-left: 32%;*/
      text-align: center;
    }
  }
}
.cursor {
  cursor: pointer;
}
.forgpass {
  padding: 0px;
  .text {
    font-size: 20px;
  }
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@media only screen and (max-width: 600px) {
  .signin-form form {
    padding: 16px 20px 25px;
  }
}
.password {
  display: flex;
  i {
    margin-left: -30px;
    margin-top: 10px;
  }
}
.pointer {
  cursor: pointer;
}
.signin {
  font-size: 20px;
  font-weight: 600;
  //color: #ffffff;  comment old code
  color: #060606;  // Add new code css
}
.separator {
  // color:#ffffff;
  border: 1px solid #ffffff;
  margin-bottom: 10px;
}

// Add new code css for sign in text
.signin-text {
  text-align: center;
}
.companyCode{
  margin-bottom:8px;
}
</style>
